<template>
    <div class="problem-container">
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
            <van-list
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                @load="getProblems"
            >
                <van-cell v-for="(item, index) in problems" :key="index" @click="goDetail(item)" is-link>
                    <template #title>
                        <span class="custom-title">·</span>
                        {{item.problemName}}
                    </template>
                </van-cell>
            </van-list>
        </van-pull-refresh>
    </div>
</template>
<script>
import { getProblems } from '@/services/common'
export default {
    data () {
        return {
            loading: false,
            finished: false,
            refreshing: false,
            total: 0,
            params: {
                current: 1,
                size: 10,
                type: 20,
                problemStatus: 20
            },
            problems: []
        }
    },
    mounted () {
        // this.getProblems()
    },
    methods: {
        goDetail (item) {
            this.$router.push(`/helper/${item.id}`)
            document.title = item.problemName
            // this.$router.push(`/helper/${item.id}?routename=${item.problemName}`)
        },
        onRefresh () {
            // 清空列表数据
            this.finished = false

            // 重新加载数据
            // 将 loading 设置为 true，表示处于加载状态
            this.loading = true
            this.getProblems()
        },
        getProblems () {
            setTimeout(() => {
                if (this.refreshing) {
                    this.problems = []
                    this.params.current = 1
                    this.refreshing = false
                }
                console.log(this.params)
                getProblems(this.params).then(res => {
                    console.log(res, res.total)
                    this.problems = this.problems.concat(res.data.records)
                    this.total = res.data.total
                    this.params.current++
                    this.loading = false
                    if (this.problems.length >= this.total) {
                        this.finished = true
                    }
                })
            }, 0)
        }
    }
}
</script>
<style lang="less" scoped>
.problem-container {
    position: absolute;
    min-height: 100%;
    width: 100%;
    background: #F7F7F7FF;
    ul {
        padding: 0 15px;
        li {
            line-height: 40px;
            border-bottom: 1px solid rgba(51, 51, 51, 0);
        }
    }
    //
}
</style>
<style lang="less">
.problem-container {
    .van-cell {
        border-bottom: 1px solid rgba(51, 51, 51, 0.04);
        &::after {
            border-bottom: none;
        }
    }
}
</style>
